<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'createTemplate',
})
</script>
<template>
  <a-modal title="取消锁定" :width="1000" :open="true" :confirmLoading="state.loading" @ok="onFormSubmit" @cancel="handleCancel" :maskClosable="false">
    <template #footer>
      <a-button key="back" @click="handleCancel">取消</a-button>
      <a-button key="submit" type="primary" :loading="state.loading" @click="onFormSubmit">取消锁定</a-button>
    </template>
    <a-spin :spinning="state.loading">
      <a-form ref="ruleForm" :model="formState" v-bind="formLayout" :rules="rules">
        <a-form-item label="主体名称">
          {{ props.detailData.full_name }}
        </a-form-item>
        <a-form-item label="锁定时间"> {{ props.detailData.start_time }} - {{ props.detailData.end_time }} </a-form-item>

        <a-form-item label="备注" name="audit_remark" required>
          <a-input placeholder="请输入" v-model:value="formState.audit_remark"></a-input>
        </a-form-item>
        <a-form-item label="附件" labelWrap="true">
          <Upload
            :upload_path="props.detailData.upload_path"
            :accept="['png', 'jpg', 'jpeg', 'pdf']"
            uploadType="picture-card"
            :limitation="99"
            :customerName="props.detailData.full_name"
            v-model:value="formState.audit_url"
            uploadText="上传附件"
          >
          </Upload>
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script lang="ts" setup name="createTemplate">
import { reactive, ref, onMounted, computed } from 'vue'
import { message } from 'ant-design-vue'
import baseService from '@/utils/http/axios'
import Upload from '@/components/base/Upload.vue'
import dayjs from 'dayjs'
const format = 'YYYY-MM-DD HH:mm:ss'
const props = defineProps({
  detailData: {
    type: Object,
    default: () => null
  }
})
const emit = defineEmits(['cancel', 'ok'])
const ruleForm = ref()
const rules = {}
const formLayout = {
  labelCol: {
    xs: { span: 7 },
    sm: { span: 7 }
  },
  wrapperCol: {
    xs: { span: 10 },
    sm: { span: 10 }
  }
}
interface state {
  loading: boolean
  free_money: string
  free_coupons: Array<any>
}
const state = reactive<state>({
  loading: false,
  free_money: '',
  free_coupons: []
})
interface formState {
  audit_remark: string
  audit_url: Array<string>
}
let formState = reactive<formState>({
  audit_remark: '',
  audit_url: []
})
onMounted(() => {})
const onFormSubmit = () => {
  ruleForm.value
    .validate()
    .then(() => {
      state.loading = true
      let requeryParam = {
        url: '/admin/v1/lockException/cancel',
        method: 'post',
        data: Object.assign({ id: props.detailData.id }, formState)
      }
      baseService(requeryParam)
        .then((res: any) => {
          state.loading = false
          message.success(res.msg)
          emit('ok')
        })
        .catch((res) => {
          state.loading = false
          if (res.msg) {
            message.error(res.msg)
          } else {
            message.error('操作失败')
          }
        })
    })
    .catch(() => {})
}
const handleCancel = () => {
  emit('cancel')
}
</script>

<style lang="less" scoped></style>
